const Full = () => import( '@/container/Full.vue')

// dashboard components
const headerHelpDesk = () => import(/* webpackPrefetch: false */ '@/views/helpdesk/HelpDeskHeaderBar.vue')
const TicketDetails = () => import(/* webpackPrefetch: false */ '@/components/Helpdesk/TicketDetails.vue')

export default {
    path: '/helpdesk',
    component: Full,
    redirect: '/helpdesk',
    beforeEnter(to, from, next) {
        if (localStorage.getItem('token')) {
            next()
        } else {
            next('/signin')
        }
    },
    children: [
        {
            path: '/helpdesk',
            component: headerHelpDesk,
            meta: {
                title: "HelpDesk"
            }
        },
        {
            path: '/helpdesk/tickets',
            component: headerHelpDesk,
            meta: {
                title: "Tickets"
            }
        },
        {
            path: '/helpdesk/tickets/null/:ticket_id',
            component: headerHelpDesk,
            meta: {
                title: "Tickets"
            }
        },
        {
            path: '/helpdesk/ticket_config',
            component: headerHelpDesk,
            meta: {
                title: "Ticket Configuration"
            }
        },
        {
            path: '/helpdesk/completed_tickets',
            component: headerHelpDesk,
            meta: {
                title: "Completed Tickets"
            }
        },
        {
            path: '/helpdesk/tat_tickets',
            component: headerHelpDesk,
            meta: {
                title: "TAT Tickets"
            }
        },
        {
            path: '/helpdesk/ticket_slas',
            component: headerHelpDesk,
            meta: {
                title: "Ticket SLA"
            }

        },
        {
            path: '/helpdesk/ticket_rules',
            component: headerHelpDesk,
            meta: {
                title: "Ticket Rules"
            }
        },
        {
            path: '/helpdesk/ticket_details/:userid',
            component: TicketDetails,
            meta: {
                title: "Ticket Details"
            }
        },
    ]
}